import {WP_STATUS} from '@/pages/components/audit/adjustment/adjust/dialogs/utils/wpStatusUtils';

export interface WpIssueMarkState {
    marked: boolean;
    remark: string;
    outstanding: boolean;
    outstandingRemark: string;
    valid: boolean;
}

export interface WpIssueMarkPayload {
    marked: boolean;
    remark?: string;
    outstanding?: boolean;
    outstandingRemark?: string;
}

export function shouldIncludeIssueMarkInSave(
    issueMark: WpIssueMarkState,
    initialWpStatus?: number | null,
    initialOutstanding?: boolean,
): boolean {
    return issueMark.marked
        || issueMark.outstanding
        || initialWpStatus === WP_STATUS.HAS_ISSUE
        || !!initialOutstanding;
}

/** 从 Facade 合并后的 currentData 或 FS line 解析初始 wpStatus */
export function resolveInitialWpStatus(
    ...sources: Array<number | null | undefined>
): number | null | undefined {
    for (const value of sources) {
        if (value != null) {
            return value;
        }
    }
    return undefined;
}

/** 构建与底稿分离的 issue mark 载荷；undefined 表示本次保存不变更 issue mark */
export function buildIssueMarkPayload(
    issueMark: WpIssueMarkState,
    initialWpStatus?: number | null,
    initialOutstanding?: boolean,
): WpIssueMarkPayload | undefined {
    if (!shouldIncludeIssueMarkInSave(issueMark, initialWpStatus, initialOutstanding)) {
        return undefined;
    }
    if (issueMark.marked && !issueMark.remark.trim()) {
        throw new Error('Issue description is required when marked as issue');
    }
    if (issueMark.outstanding && !issueMark.outstandingRemark.trim()) {
        throw new Error('Outstanding description is required when marked as outstanding');
    }
    return {
        marked: issueMark.marked,
        remark: issueMark.marked ? issueMark.remark : '',
        outstanding: issueMark.outstanding,
        outstandingRemark: issueMark.outstanding ? issueMark.outstandingRemark : '',
    };
}

/** @deprecated 使用 buildIssueMarkPayload，issue mark 不再写入 details */
export function applyIssueMarkToDetails<T extends object>(
    details: T,
    issueMark: WpIssueMarkState,
    initialWpStatus?: number | null,
    initialOutstanding?: boolean,
): T & {wpIssueRemark?: string} {
    const payload = buildIssueMarkPayload(issueMark, initialWpStatus, initialOutstanding);
    if (!payload) {
        return details;
    }
    return {
        ...details,
        wpIssueRemark: payload.marked ? payload.remark : '',
    };
}
